import { hotList, recapData } from "../../../mocks/fortyone";

export default function RecapSection() {
  return (
    <section id="recap" className="py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide whitespace-nowrap">
            <i className="ri-flashlight-line"></i>
            精选回顾
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mt-4">
            值得回看的那些内容
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            编辑部挑选的深度整理与热门话题，一篇文章补上完整脉络。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-5">
          {recapData.map((r) => (
            <article
              key={r.title}
              className="group rounded-xl bg-background-100 overflow-hidden border border-background-200 hover:border-primary-300 transition-colors flex flex-col"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={r.image}
                  alt={r.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-background-50/90 text-primary-700 text-xs font-semibold whitespace-nowrap">
                  {r.tag}
                </span>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-base font-bold text-foreground-950 leading-snug">{r.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">{r.desc}</p>
                <a
                  href="#faq"
                  className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-primary-600 group-hover:gap-2 transition-all whitespace-nowrap"
                >
                  阅读完整脉络 <i className="ri-arrow-right-line text-xs"></i>
                </a>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-10 rounded-2xl bg-background-100 border border-background-200 p-5 md:p-8 grid grid-cols-1 lg:grid-cols-[1fr_1.4fr] gap-6">
          <div>
            <h3 className="font-heading text-xl md:text-2xl font-black text-foreground-950">
              当下正在发酵的热门脉络
            </h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
              追踪各平台仍在讨论的话题，编辑部持续把新进展补进对应时间线，方便你实时跟读。
            </p>
            <a
              href="#contact"
              className="mt-4 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-accent-500 hover:bg-accent-600 text-foreground-950 text-sm font-bold whitespace-nowrap transition-colors"
            >
              点播你想看的方向
            </a>
          </div>
          <div className="flex flex-col">
            {hotList.map((h, i) => (
              <a
                key={h.rank}
                href="#timeline"
                className="group flex items-center gap-4 px-1 py-3 border-b border-background-200 last:border-0 hover:bg-background-50 transition-colors rounded-md"
              >
                <span
                  className={`font-heading text-xl font-black w-8 text-center ${
                    i < 3 ? "text-primary-500" : "text-foreground-300"
                  }`}
                >
                  {h.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-foreground-900 truncate">{h.title}</p>
                  <span className="text-xs text-foreground-400">{h.hot}</span>
                </div>
                <span className="px-2.5 py-1 rounded-full bg-background-100 text-foreground-500 text-xs whitespace-nowrap">
                  {h.tag}
                </span>
                <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors text-lg"></i>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}